import axios from "axios";
import _Vue from "vue";
import AuthRouter from "@/context/security/router/AuthRouter";

export class AxiosPluginOptions {
  // add stuff
}

export const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_AXIOS_BASE_URL
});

axiosInstance.interceptors.request.use(async config => {
  const token = localStorage.getItem("telemetric-data-server-frontend-token");
  if (token && token != "") {
    // config.headers = {
    //   Authorization: `Bearer ${token}`
    // };
    config.headers = {
      Authorization: `Basic ${token}`
    };
  } else {
    window.location.href = process.env.VUE_APP_PRODUCTION_URL;
  }
  return config;
});
const UNAUTHORIZED = 401;
axios.interceptors.response.use(
  response => response,
  error => {
    const { status } = error.response;
    if (status === UNAUTHORIZED) {
      // window.location.href = process.env.VUE_APP_PRODUCTION_URL;
      window.location.href = process.env.VUE_APP_PRODUCTION_URL;
    }
    return Promise.reject(error);
  }
);

export function AxiosPlugin<AxiosPlugOptions>(
  Vue: typeof _Vue,
  options?: AxiosPluginOptions
): void {
  // do stuff with options
  // eslint-disable-next-line no-param-reassign
  Vue.prototype.$http = axiosInstance;
}

axiosInstance.interceptors.request.use(config => config);
